import { Box, Text } from '@chakra-ui/react';
import InformIcon from '../../../assets/inform-green-icon.svg';
import { TooltipComponent } from '../../Tooltip';

const RequestCard = ({ request, showStatus = false, tooltips }) => {
  return (
    <div>
      <div className="grid grid-rows-[auto,auto,auto] gap-[10px]">
        <div className="flex items-center gap-[5px]">
          <span className="text-growth-green-500 font-[600] text-sm flex items-center gap-[5px]">
            Proposed Equity
            <TooltipComponent description={tooltips} Icon={InformIcon} />:
          </span>
          <span className="text-sm">{request?.equityPercentage}%</span>
        </div>
        {showStatus ? (
          <div className="flex items-center gap-[5px]">
            <span className="text-growth-green-500 font-[600] text-sm flex items-center gap-[5px]">
              Request status :
            </span>
            <Box
              px={'12px'}
              py={'1.5px'}
              rounded={'80px'}
              bgColor={request.status === 'closed' ? '#4CAF50' : '#EDF7EE'}
              w={'fit-content'}
            >
              <Text
                color={request.status === 'closed' ? '#FFFFFF' : '#204A22'}
                fontWeight={request.status === 'closed' ? 800 : 600}
                fontSize={'xs'}
              >
                {request.status === 'closed' ? 'Closed' : 'Ongoing'}
              </Text>
            </Box>
          </div>
        ) : (
          <></>
        )}
        <div className="font-[800] overflow-hidden text-lg whitespace-wrap">{request?.title}</div>
        <div className="overflow-hidden text-justify whitespace-wrap">{request?.description}</div>
      </div>
    </div>
  );
};

export default RequestCard;
